export const CHECK_IN = "CHECK_IN";
export const CHECK_IN_BY_PNR = "CHECK_IN_BY_PNR";
export const PAX_CHECKIN = "PAX_CHECKIN";
export const SEAT_CHECKIN = "SEAT_CHECKIN";
export const DESTINATION_DETAILS = "DESTINATION_DETAILS";
